module.exports = __webpack_public_path__ + "img/career-lab.d8542669.svg";